import Reveal from "@/components/feature/Reveal";
import SectionHeading from "./SectionHeading";
import { categories } from "@/mocks/categories";

export default function Categories() {
  return (
    <section id="categories" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal>
            <SectionHeading
              eyebrow="热门分类"
              title="长期征集的八类线索"
              description="下面每个分类都在持续接收投稿。如果你手上的线索恰好落在其中，说明已经有人在做类似的事——你的一份细节，往往就是补上拼图的那一块。"
            />
          </Reveal>
          <Reveal delay={80}>
            <a
              href="#tips"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-3 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-50"
            >
              查看近期精选线索
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </Reveal>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:mt-14 lg:grid-cols-4">
          {categories.map((cat, index) => (
            <Reveal key={cat.id} delay={(index % 4) * 70} className="h-full">
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600 md:h-12 md:w-12 md:text-2xl">
                    <i className={cat.icon} aria-hidden="true" />
                  </span>
                  <span className="font-heading text-sm font-bold text-foreground-400">
                    {cat.count}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {cat.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <a
                  href="#submit"
                  className="mt-5 inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  投稿到该分类
                  <i className="ri-arrow-right-s-line" aria-hidden="true" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}